import { Injectable, Inject, CSP_NONCE, DOCUMENT } from '@angular/core';
import { ReplaySubject, Observable } from 'rxjs';


@Injectable()
export class LazyLoadScriptService {
  loadedLibraries: { [url: string]: ReplaySubject<void> } = {};

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    @Inject(CSP_NONCE) private _nonce: string,
  ) {}

  loadScript(url: string): Observable<void> {
    if (!this.loadedLibraries[url]) {
      this.loadedLibraries[url] = new ReplaySubject();

      const script = this.document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.setAttribute('nonce', this._nonce);
      script.onload = () => {
        this.loadedLibraries[url].next();
        this.loadedLibraries[url].complete();
      };
  
      this.document.body.appendChild(script);
    }
    
    return this.loadedLibraries[url].asObservable();
  }
}
